import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import './CircularLoader.scss';

const CircularLoader = ()=> {
  return (
    <div className='circularLoaderContainer'>
      <CircularProgress className='circularLoader' />
    </div>
  );
};

export default CircularLoader;